import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, of, switchMap } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { GdprCandidateHttpClient } from './gdpr-candidate-http-client';
import { GdprCandidateActions } from './gdpr-candidate.store';

@Injectable({ providedIn: 'root' })
export class GdprCandidateEffects {
  public extendExpiry$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GdprCandidateActions.extendExpiry),
      mergeMap(({ payload }) =>
        this.gdprCandidateHttpClient
          .extendExpiry(payload.candidateId, payload.gdprCustomExpiresAt)
          .pipe(
            switchMap(({ candidate, references }) => [
              GdprCandidateActions.extendExpirySuccess({ payload: { candidate, references } }),
            ]),
            catchError(error =>
              of(
                GdprCandidateActions.extendExpiryFailed({
                  payload: { error, candidateId: payload.candidateId },
                }),
              ),
            ),
          ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private gdprCandidateHttpClient: GdprCandidateHttpClient,
  ) {}
}
